import PropTypes from 'prop-types';
import React, { memo } from 'react';
import { List } from 'immutable';
import { ContextMenu, MenuItem, ContextMenuTrigger } from 'react-contextmenu';

import Table, { Column, Row } from '../../helpers/Table';
import { IconButton } from '../../helpers/IconButton';
import Tooltip from '../../helpers/DataToolTip';
import Input from '../../helpers/Input';
import Span from '../../helpers/Span';
import uniqueId from '../../../utils/uniqueId';
import { unwrap } from '../../../utils/ChangeSpy';

const ContextMenuWrapper = onClick => {
  const ContextMenuWrapped = (value, data) => {
    const id = uniqueId();

    return (
      <div>
        <ContextMenuTrigger id={id}>{value}</ContextMenuTrigger>

        <ContextMenu id={id}>
          <MenuItem data={data.toJS()} onClick={onClick}>
            <i className="fa fa-remove" /> Delete
          </MenuItem>
        </ContextMenu>
      </div>
    );
  };

  return ContextMenuWrapped;
};

const Wrapper = onClick => (value, data, i) => {
  let content = (
    <Tooltip content={data.get('dateString', '')}>
      <Span checkOn="children" minSizes>
        {value}
      </Span>
    </Tooltip>
  );

  if (data.get('isEditing')) {
    content = <Input name={`harvcoTags.${i}.tag`} placeholder="" value={value} autoFocus />;
  }

  return ContextMenuWrapper(onClick)(content, data);
};

/**
 * Contact executive table with harvco tags.
 *
 * @param props {Object}.
 * @param props.tags {Immutable.List} Tags definition.
 */
const ContactExecutiveHarvcoTags = ({ tags, onAdd, onClick, onChange, onDelete }) => {
  const title = (
    <>
      <IconButton className="mr5" icon="plus" onClick={onAdd} size="sm" title="Add HarvCo tag" variant="primary" />
      <span>HarvCo Tags</span>
    </>
  );
  const rows = tags.map((tag, i) => (
    <Row
      key={unwrap(tag.get('id'))}
      className="clickable"
      data={tag}
      onChange={onChange}
      onClick={event => onClick(event, i)}
    />
  ));

  return (
    <div className="highlight table-responsive ib">
      <Table className="table table-bordered table-hover">
        <Column className="plus-icon" field="tag" title={title} valueWrapper={Wrapper(onDelete)} />
        {rows}
      </Table>
    </div>
  );
};

ContactExecutiveHarvcoTags.propTypes = {
  tags: PropTypes.instanceOf(List).isRequired,
};

export default memo(ContactExecutiveHarvcoTags);
